// Module for app-wide configurations
const REDIS_URL = process.env.REDISCLOUD_URL;
const REDIS_JOBS_URL = process.env.REDIS_JOBS_URL;

// ENVIRONMENT TYPES
const ENVIRONMENT_STAGE = process.env.ENVIRONMENT_STAGE || "staging";
const IS_PRODUCTION = ENVIRONMENT_STAGE === "production";
const IS_DEVELOPMENT = ENVIRONMENT_STAGE === "development";

// DOMAINS

// can be over-ridden by the environment, presumably for testing reasons
// Note: do not use these domains in Webpack builds yet (the process.env stuff is not yet working)
const domains = {
    marketing: process.env.SUGARWOD_URL_MARKETING || "https://www.sugarwod.com",
    app: process.env.SUGARWOD_URL_APP || "https://app.sugarwod.com",
    api: process.env.SUGARWOD_URL_API || "https://api.sugarwod.com",
    cdn: process.env.SUGARWOD_URL_CDN || "https://cdn.sugarwod.com",
    help: process.env.DAXKO_HELP_CENTER || "https://daxkosites.force.com",
    blog: process.env.SUGARWOD_URL_BLOG || "https://blog.sugarwod.com",
};

// URLS
const urls = {
    faqs: domains.help + "/DaxkoCommunityHub/s/sugarwod-community-homepage",
    private_vs_public_tracks:
        domains.help +
        "/DaxkoCommunityHub/s/article/SUGARWOD-Workout-Tracks-Private-Group-vs-Public",
    active_vs_inactive_tracks:
        domains.help +
        "/DaxkoCommunityHub/s/article/SUGARWOD-Workout-Tracks-Active-vs-Inactive",
    view_different_tracks:
        domains.help +
        "/DaxkoCommunityHub/s/article/SUGARWOD-How-to-View-workouts-for-different-Workout-Tracks-on-my-Whiteboard",
    security_settings_faq:
        domains.help +
        "/DaxkoCommunityHub/s/article/SUGARWOD-Security-Settings",
    workout_notifications_timing:
        domains.help +
        "/DaxkoCommunityHub/s/article/SUGARWOD-How-do-I-set-up-the-publishing-time-for-workouts-in-my-gym",
    plugin_installation:
        domains.help +
        "/DaxkoCommunityHub/s/article/SUGARWOD-Plug-in-installation-and-configuration-instructions",
    rss_publishing:
        domains.help +
        "/DaxkoCommunityHub/s/article/SUGARWOD-How-do-I-publish-my-workouts-via-RSS",
    html_publishing:
        domains.help +
        "/DaxkoCommunityHub/s/article/What-are-the-CSS-classes-used-in-the-HTML-pages",
    box_tv:
        domains.help +
        "/DaxkoCommunityHub/s/article/SUGARWOD-What-are-the-Technical-Requirements-for-Box-TV",
    transfer_ownership:
        domains.help +
        "/DaxkoCommunityHub/s/article/SUGARWOD-How-do-I-transfer-ownership-of-my-gym-s-SugarWOD-account",
    add_remove_coach:
        domains.help +
        "/DaxkoCommunityHub/s/article/How-to-add-or-remove-a-Coach",
    cancel_programming_sub:
        domains.help +
        "/DaxkoCommunityHub/s/article/SUGARWOD-How-do-I-cancel-my-Individual-Programming-subscription",
    app_store_listing_ios:
        "https://itunes.apple.com/us/app/sugarwod/id665516348?mt=8",
    app_store_listing_android:
        "https://play.google.com/store/apps/details?id=com.flatironssoftware.sugarwod",
    train_hard_app_store_listing_ios:
        "https://apps.apple.com/us/app/train-hard-fitness-app/id6451003857",
    train_hard_app_store_listing_android:
        "https://play.google.com/store/apps/details?id=com.daxko.sugarwod.trainhard",
    prvn_app_store_listing_ios:
        "https://apps.apple.com/app/prvn-fitness-app/id6504539787",
    prvn_app_store_listing_android:
        "https://play.google.com/store/apps/details?id=com.daxko.sugarwod.prvn",
    marketplace: domains.app + "/marketplace",
    programming_calendar: domains.app + "/workouts/calendar",
    subscription_workout_download_prefix:
        domains.app + "/workouts/subscriptions",
    contact_form: domains.marketing + "/contact",
    homepage: domains.app + "/home",

    admin_publisher_ui_prefix:
        domains.app + "/sugarwod-admin/marketplace/publishers",
    admin_affiliate_ui_prefix: domains.app + "/sugarwod-admin/gyms",
    admin_athlete_ui_prefix: domains.app + "/sugarwod-admin/athletes",

    scheduling_integration_guide:
        "https://app.sugarwod.com/gyms/connect-remote-athletes/zenplanner/guided",
    scheduling_integration_help_article:
        "https://help.sugarwod.com/hc/en-us/articles/4414622204311",

    sugarwod_full_color:
        domains.cdn +
        "/static/images/logos/2018/sugarwod-daxko-fullidentitymark-horizontal.png",
    sugarwod_full_color_sugar_white:
        domains.cdn +
        "/static/images/logos/2018/sugarwod-daxko-fullidentitymark-horizontal-white.png",
    sugarwod_full_black:
        domains.cdn +
        "/static/images/logos/2018/sugarwod-fullidentitymark-horizontal-blk.png",
    sugarwod_full_white:
        domains.cdn +
        "/static/images/logos/2018/sugarwod-fullidentitymark-horizontal-wht.png",
    sugarwod_type_black:
        domains.cdn + "/static/images/logos/2018/sugarwod-type-blk.png",
    sugarwod_type_white:
        domains.cdn + "/static/images/logos/2018/sugarwod-type-wht.png",
    sugarwod_logo_color:
        domains.cdn + "/static/images/logos/2018/sugarwod-mark-180.png",
    sugarwod_logo_yellow:
        domains.cdn + "/static/images/logos/2018/sugarwod-mark-yellow-360.png",
};

// PATHS

const basePaths = {
    public_js: "/js/sugarwod",
    sugar_css: "/css/sugarwod-20200123-whiteboard-video.css", // cache buster naming
    gym_prefix: "",
    public_prefix: "/public",
    home: "/home",
    admin_path_component: "sugarwod-admin",
    marketplace_path_component: "marketplace",
};

const paths = {
    ...basePaths,
    // sugar_shared_js: paths.public_js + '/shared.min.js',
    sugar_app_js:
        basePaths.public_js + "/app-20200414-refactor-to-webpack.min.js", // cache buster naming
    sugar_admin_js: basePaths.public_js + "/admin.min.js", // cache buster naming
    sugar_search_js: basePaths.public_js + "/search.js",

    gym_ui_prefix: basePaths.gym_prefix + "/gyms",
    gym_api_prefix: basePaths.gym_prefix + "/api",
    gym_ui_settings_prefix: basePaths.gym_prefix + "/gyms/settings",

    public_api_prefix: basePaths.public_prefix + "/api/v1",

    marketplace_ui_prefix: "/" + basePaths.marketplace_path_component,

    admin_ui_prefix: "/" + basePaths.admin_path_component,
    admin_ui_gym_editor: "/" + basePaths.admin_path_component + "/gyms",
    admin_api_prefix: "/" + basePaths.admin_path_component + "/api",
    admin_api_gyms: "/" + basePaths.admin_path_component + "/api/gyms",
    admin_prefix: "/" + basePaths.admin_path_component,

    choose_password: "/choose-password",
    password_reset_success: "/password-reset-success",
};

const skin = {
    string: {
        marketplace_name: "SugarWOD Marketplace",
    },
    color: {
        primary: "#2296F3",
        accent: "#DB00AB",
        accent_2: "#dbbe00",
        success: "#5EB800",
        danger: "#CC4000",
    },
};

const analytics = {
    gtm: process.env.SUGARWOD_GOOGLE_TAG_MANAGER || null,
};

// CACHE
const caches = {
    public_api_prefix: paths.public_api_prefix,
    prefix: "cache",
    moves_prefix: "moves/",
    lw_prefix: "lw/",
    lws_prefix: "lws/",
    bbls_prefix: "bbls/",
    affiliate_prefix: "aff/",
    publishers_prefix: "pubs/",
    publishers_and_products: "pubs_and_prods/",
    marketplace_taxonomy: "marketplace_taxonomy/",
    public_api_affiliates_prefix: paths.public_api_prefix + "/affiliates",
    delete_callback: function () {
        //cannot remove this function as of now as it has many usages and can't remove them all
        console.log("delete_callback called");
    }, // TODO: This function doesn't do anything, should we remove it?
};

const isConfigVarTruthy = (varName) => {
    const configVar = process.env[varName];
    // heroku configVar are strings, a config var value of "0" will evaluate true
    // hence the need for this function
    return (
        configVar &&
        (configVar === "1" ||
            configVar.toLowerCase() === "yes" ||
            configVar.toLowerCase() === "true" ||
            configVar.toLowerCase() === "on")
    );
};

const ALGOLIA_APP_ID = process.env.ALGOLIA_APP_ID;

const ALGOLIA_ADMIN_API_KEY = process.env.ALGOLIA_ADMIN_API_KEY;

const ALGOLIA_PUBLIC_SEARCH_API_KEY = process.env.ALGOLIA_PUBLIC_SEARCH_API_KEY;

const ALGOLIA_WRITE_API_KEY = process.env.ALGOLIA_WRITE_API_KEY;
const ALGOLIA_PUBLIC_ATHLETE_SEARCH_API_KEY =
    process.env.ALGOLIA_PUBLIC_ATHLETE_SEARCH_API_KEY;
const ALGOLIA_PUBLIC_AFFILIATE_SEARCH_API_KEY =
    process.env.ALGOLIA_PUBLIC_AFFILIATE_SEARCH_API_KEY;
const ALGOLIA_PUBLIC_MOVEMENTS_LIBRARY_WORKOUTS_SEARCH_API_KEY =
    process.env.ALGOLIA_PUBLIC_MOVEMENTS_LIBRARY_WORKOUTS_SEARCH_API_KEY;
const ALGOLIA_PUBLIC_WORKOUTS_SEARCH_API_KEY =
    process.env.ALGOLIA_PUBLIC_WORKOUTS_SEARCH_API_KEY;
const ALGOLIA_PUBLIC_WORKOUTS_ATHLETES_API_KEY =
    process.env.ALGOLIA_PUBLIC_WORKOUTS_ATHLETES_API_KEY;
const ALGOLIA_INSIGHTS_URL = process.env.ALGOLIA_INSIGHTS_URL;

/*
 * Algolia Index Configuration:
 * This setup allows us to assign API keys for different indexes.
 * Currently, all indexes use the same public search API key.
 * If needed, we can update this configuration to assign
 * different keys for specific indexes in the future.
 */
const ALGOLIA_INDEXES = {
    Affiliates: ALGOLIA_PUBLIC_SEARCH_API_KEY,
    Athletes: ALGOLIA_PUBLIC_SEARCH_API_KEY,
    Workouts: ALGOLIA_PUBLIC_SEARCH_API_KEY,
    Products: ALGOLIA_PUBLIC_SEARCH_API_KEY,
};

module.exports = {
    ALGOLIA_ADMIN_API_KEY,
    ALGOLIA_APP_ID,
    ALGOLIA_INSIGHTS_URL,
    ALGOLIA_PUBLIC_AFFILIATE_SEARCH_API_KEY,
    ALGOLIA_PUBLIC_ATHLETE_SEARCH_API_KEY,
    ALGOLIA_PUBLIC_MOVEMENTS_LIBRARY_WORKOUTS_SEARCH_API_KEY,
    ALGOLIA_PUBLIC_SEARCH_API_KEY,
    ALGOLIA_PUBLIC_WORKOUTS_ATHLETES_API_KEY,
    ALGOLIA_PUBLIC_WORKOUTS_SEARCH_API_KEY,
    ALGOLIA_WRITE_API_KEY,
    ENVIRONMENT_STAGE,
    IS_DEVELOPMENT,
    IS_PRODUCTION,
    REDIS_JOBS_URL,
    REDIS_URL,
    analytics,
    caches,
    domains,
    isConfigVarTruthy,
    paths,
    skin,
    urls,
    ALGOLIA_INDEXES,
};
